<template>
  <el-cascader
    class="filter-item"
    :props="{
      multiple,
      checkStrictly,
    }"
    :options="proSysNumList"
    clearable
    @change="handleChange"
    :value="value"
  ></el-cascader>
</template>

<script>
import { getCurriculumSystem } from "@/api/course";

export default {
  props: {
    // 添加props接收外部传入的值
    modelValue: {
      type: Array,
      default: () => [],
    },
    checkStrictly: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    isOnlyLastNode: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      value: this.modelValue || [],
      proSysNumList: [],
    };
  },
  mounted() {
    getCurriculumSystem().then((res) => {
      this.proSysNumList = res.data;
    });
  },
  methods: {
    handleChange(value) {
      console.log("原始value", value);
      this.value = value;

      // 只向外传递最后一层的元素
      if (value && value.length > 0) {
        if (this.isOnlyLastNode) {
          // 获取最后一个选中的节点
          const lastNode = value[value.length - 1];
          console.log("传递最后一层元素", lastNode);
          this.$emit("input", [lastNode]);
          this.$emit("update:modelValue", [lastNode]);
        } else {
          this.$emit("input", value);
          this.$emit("update:modelValue", value);
        }
      } else {
        // 如果没有选择，则传递空数组
        this.$emit("input", []);
        this.$emit("update:modelValue", []);
      }
    },
  },
  watch: {
    // 监听外部传入的值变化
    modelValue(newVal) {
      this.value = newVal;
    },
  },
};
</script>

<style lang="less" scoped></style>
